import { composeValidators } from '@alfa-bank/site-form-helpers/validation/utils';
import { validateBirthday } from '@alfa-bank/site-form-birthday/src/helpers';

export const validatePassportDate = () =>
    composeValidators(validateBirthday('Некорректная дата', 0, undefined, true));
